import React from 'react'
import dealparties1Image from '/app/assets/images/beacon/questionnaire-beacon.png'

const Rectangle = ({ currentStep }) => {
  const commonStyle = {
    height: currentStep === 0 ? 4 : 2.5,
    borderRadius: '100px',
    background: 'var(--accent, #F0F0F0)',
    transition: 'all 0.5s ease-in-out',
  }

  const commonWidth = currentStep === 0 ? 0 : -20

  return (
    <div style={{ gap: 8 }} className="dome-d-flex dome-flex-column">
      <div style={{ width: 87 + commonWidth, ...commonStyle }}></div>
      <div style={{ width: 90 + commonWidth, ...commonStyle }}></div>
      <div style={{ width: 63 + commonWidth, ...commonStyle }}></div>
      <div style={{ width: 63 + commonWidth, ...commonStyle }}></div>
    </div>
  )
}

const BeaconImage = ({ currentStep }) => {
  const layoutStyle = () => {
    if (currentStep === 0) return { width: 244, height: 163 }
    return { width: 300, height: 200 }
  }

  const rectangleStyle = () => {
    if (currentStep === 0) return { top: '57px', left: '40px' }
    return { top: '45px', left: '36px' }
  }

  const contentStyle = () => {
    if (currentStep === 0) return { scale: '1' }
    if (currentStep === 1) return { scale: '1.8', transform: 'translate(65px, 44px)' }
    if (currentStep >= 2) return { scale: '2.5', transform: 'translate(-45px, 48px)' }
  }

  const higlighContentStyle = () => {
    if (currentStep >= 2) return { opacity: 1, left: '170.5px' }
  }

  return (
    <div className="questionnaire-beacon-image-container" style={{ ...layoutStyle() }}>
      <div className="questionnaire-beacon-image-body" style={{ ...contentStyle() }}>
        <div className="questionnaire-beacon-image-backdrop"></div>
        <div style={{ position: 'absolute', zIndex: 2, ...rectangleStyle(), transition: 'all 0.5s ease-in-out' }}>
          <Rectangle currentStep={currentStep} />
        </div>
        <div className="questionnaire-beacon-image-content-highlight" style={{ ...higlighContentStyle() }}></div>
        <img style={{ width: 270, height: 222, transform: 'translate(-14px, -31px)' }} src={dealparties1Image} />
      </div>
    </div>
  )
}

export default BeaconImage
